import { render, staticRenderFns } from "./DropdownGroupEl.vue?vue&type=template&id=65e44544&scoped=true&"
import script from "./DropdownGroupEl.vue?vue&type=script&lang=ts&"
export * from "./DropdownGroupEl.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownGroupEl.vue?vue&type=style&index=0&id=65e44544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e44544",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
